export default (primaryColor) => {
  return {
    useNextVariants: true,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 600,
    color: "#444",
    h1: {
      fontSize: "2rem !important",
      fontWeight: "600 !important",
      lineHeight: "1.2 !important",
      color: primaryColor,
      fontFamily: "DMSans !important",
    },
    h2: {
      fontSize: "1.75rem",
      fontWeight: 600,
      lineHeight: 1.2,
      color: primaryColor,
      fontFamily: "DMSans !important",
    },
    h3: {
      fontSize: "1.5rem",
      fontWeight: 600,
      lineHeight: 1.2,
      color: primaryColor,
      fontFamily: "DMSans !important",
    },
    h4: {
      fontSize: "1.25rem !important",
      fontWeight: 600,
      lineHeight: 1.2,
      color: primaryColor,
      fontFamily: "DMSans !important",
    },
    h5: {
      fontSize: "1.125rem",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "#444",
      fontFamily: "DMSans !important",
    },
    h6: {
      fontSize: "1.0625rem",
      fontWeight: 100,
      lineHeight: 1.2,
      color: "#444",
      fontFamily: "DMSans !important",
    },
    body1: {
      fontSize: 14,
      fontFamily: "Iter",
    },
    button: {
      textTransform: "none",
      fontFamily: "DMSans !important",
    },
  };
};
